import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1688547875764'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='3361'
    >
        <path
            d='M997.888 70.144C686.592 261.12 460.8 502.272 358.912 623.104l-248.832-195.072-110.08 88.576 429.568 437.248c73.728-189.44 308.224-559.616 594.432-822.784l-26.112-60.928m0 0z'
            fill='currentColor'
            p-id='3362'
        ></path>
    </svg>
)

export const RightIcon = props => <Icon component={SVG} {...props} />
